export default __webpack_public_path__ + "static/media/404_error_emoji_Large.166be1d2.png";